module.exports = __webpack_public_path__ + "images/tool-icon-white.svg";